// import React, { useEffect, useState, useRef } from "react";
// import {
//   Link,
//   useLocation,
//   useNavigate,
//   Routes,
//   Route,
// } from "react-router-dom";
// import AttendancePage from "../pages/AttendancePage";
// import Navbar from "./common/Navbar";
// import "../Assets/CSS/Layouts.css"; // Import custom CSS
// // import { Icon } from "@iconify/react/dist/iconify.js";
// import { Icon } from "@iconify/react";
// import { jwtDecode } from "jwt-decode";

// export const getUserRole = (token) => {
//   try {
//     const decoded = jwtDecode(token);
//     console.log("Decoded JWT:", decoded);

//     const roles = decoded.roles || []; // roles array from token
//     const userName = decoded.userName || decoded.sub || null; // subject claim

//     // Expiration (exp is in seconds, convert to ms)
//     const expiryTime = decoded.exp ? decoded.exp * 1000 : null;

//     return { roles, userName, expiryTime };
//   } catch (error) {
//     console.error("Invalid token", error);
//     return { roles: [], userName: null, expiryTime: null };
//   }
// };

// const Layout = ({ children }) => {
//   const sidebarRef = useRef(null);
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
//   const [isLoggedOut, setIsLoggedOut] = useState(false);
//   const location = useLocation();
//   const navigate = useNavigate();
//   const token = localStorage.getItem("token");
//   const { roles = [] } = getUserRole(token); // default to empty array
//   // Check if user is on Onboarding Profile page

//   const getOffboardingLabel = (roles) => {
//     if (roles.includes("ROLE_ADMIN")) return "Admin Offboarding";
//     if (roles.includes("ROLE_HR")) return "HR Offboarding";
//     if (roles.includes("ROLE_MANAGER")) return "Manager Offboarding";
//     if (roles.includes("ROLE_EMP")) return "Employee Offboarding";
//     if (roles.includes("ROLE_FINANCE")) return "Offboarding";
//     if (roles.includes("ROLE_IT_MANAGER")) return "Offboarding";
//     return "Offboarding";
//   };

//   const menus = [
//     {
//       label: "Dashboard",
//       icon: "mage:dashboard",
//       activeIcon: "mage:dashboard-fill",
//       link:
//         roles.includes("ROLE_ADMIN") ||
//         roles.includes("ROLE_HR") ||
//         roles.includes("ROLE_IT_MANAGER") ||
//         roles.includes("ROLE_FINANCE") ||
//         roles.includes("ROLE_SYSTEM_ADMIN")
//           ? "/admin-dashboard"
//           : "/employee-dashboard",
//       visible:
//         roles.includes("ROLE_ADMIN") ||
//         roles.includes("ROLE_EMP") ||
//         roles.includes("ROLE_MANAGER") ||
//         roles.includes("ROLE_HR") ||
//         roles.includes("ROLE_IT_MANAGER") ||
//         roles.includes("ROLE_FINANCE") ||
//         roles.includes("ROLE_SYSTEM_ADMIN"),
//     },

//     {
//       label: "My Dashboard",
//       icon: "material-symbols:event-outline-rounded",
//       activeIcon: "material-symbols:event",
//       link: "/employee-dashboard",
//       visible: roles.includes("ROLE_ADMIN"),
//     },

//     // ================= TEAM MANAGEMENT =================
//     {
//       label: "My Team",
//       icon: "material-symbols:group-outline",
//       visible:
//         roles.includes("ROLE_MANAGER") ||
//         roles.includes("ROLE_ADMIN") ||
//         roles.includes("ROLE_HR"),

//       children: [
//         {
//           label: "Employee Manager",
//           link: "/emp-management",
//           visible:
//             roles.includes("ROLE_ADMIN") ||
//             roles.includes("ROLE_MANAGER") ||
//             roles.includes("ROLE_HR"),
//         },

//         {
//           label: "Employee Timesheet",
//           link: "/admin-timesheet",
//           visible:
//             roles.includes("ROLE_ADMIN") ||
//             roles.includes("ROLE_MANAGER") ||
//             roles.includes("ROLE_HR"),
//         },

//         {
//           label: "Create Team",
//           link: "/teamList",
//           visible:
//             roles.includes("ROLE_ADMIN") || roles.includes("ROLE_MANAGER"),
//         },

//         {
//           label: "Project Tracking",
//           link: "/projectdashboard",
//           visible:
//             roles.includes("ROLE_ADMIN") || roles.includes("ROLE_MANAGER"),
//         },
//       ],
//     },
//     // {
//     //   label: "Employee's Timesheet",
//     //   icon: "solar:sort-by-time-linear",
//     //   activeIcon: "solar:sort-by-time-bold",
//     //   link:
//     //     roles.includes("ROLE_ADMIN") ||
//     //     roles.includes("ROLE_MANAGER") ||
//     //     roles.includes("ROLE_HR") ||
//     //     roles.includes("ROLE_IT_MANAGER") ||
//     //     roles.includes("ROLE_FINANCE") ||
//     //     roles.includes("ROLE_SYSTEM_ADMIN")
//     //       ? "/admin-timesheet"
//     //       : "/timesheet",
//     //   visible:
//     //     roles.includes("ROLE_ADMIN") ||
//     //     roles.includes("ROLE_MANAGER") ||
//     //     roles.includes("ROLE_HR") ||
//     //     roles.includes("ROLE_IT_MANAGER") ||
//     //     roles.includes("ROLE_FINANCE") ||
//     //     roles.includes("ROLE_SYSTEM_ADMIN"),
//     // },
//     // ================= HR MANAGEMENT =================
//     {
//       label: "Employee Management",
//       icon: "material-symbols:person-add-outline",

//       visible:
//         roles.includes("ROLE_ADMIN") ||
//         roles.includes("ROLE_MANAGER") ||
//         roles.includes("ROLE_HR"),

//       children: [
//         {
//           label: "Employee Onboarding",
//           link: "/emp-onbaord",
//           visible: roles.includes("ROLE_ADMIN") || roles.includes("ROLE_HR"),
//         },

//         {
//           label: "Appointment Status",
//           link: "/onboardAppoint-approve",
//           visible:
//             roles.includes("ROLE_ADMIN") ||
//             roles.includes("ROLE_MANAGER") ||
//             roles.includes("ROLE_HR"),
//         },

//         // {
//         //   label: "Resume Parser",
//         //   link: "/resume-parsur",
//         //   visible: roles.includes("ROLE_ADMIN"),
//         // },

//         // {
//         //   label: "CMS",
//         //   link: "/annexure-salary",
//         //   visible: roles.includes("ROLE_ADMIN"),
//         // },

//         // {
//         //   label: "Employee Offboarding",
//         //   link: "/off-boarding-employee",
//         //   visible:
//         //     roles.includes("ROLE_ADMIN") ||
//         //     roles.includes("ROLE_HR") ||
//         //     roles.includes("ROLE_EMP"),
//         // },

//         {
//           label: "Offboarding",
//           link: "/off-boarding",
//           visible:
//             roles.includes("ROLE_ADMIN") ||
//             roles.includes("ROLE_HR") ||
//             roles.includes("ROLE_MANAGER"),
//         },

//         {
//           label: "Offboarding Configuration",
//           link: "/off-boarding-config",
//           visible: roles.includes("ROLE_ADMIN"),
//         },
//       ],
//     },

//     {
//       label: "My Timesheet",
//       icon: "solar:sort-by-time-linear",
//       activeIcon: "solar:sort-by-time-bold",
//       link:
//         roles.includes("ROLE_MANAGER") ||
//         roles.includes("ROLE_EMP") ||
//         roles.includes("ROLE_ADMIN")
//           ? "/timesheet"
//           : "/timesheet",
//       visible:
//         roles.includes("ROLE_EMP") ||
//         roles.includes("ROLE_MANAGER") ||
//         roles.includes("ROLE_ADMIN"),
//     },

//     {
//       label: "Leave Management",
//       icon: "material-symbols:event-outline-rounded",
//       activeIcon: "material-symbols:event",
//       link: "/leave-management",
//       visible:
//         roles.includes("ROLE_MANAGER") ||
//         roles.includes("ROLE_ADMIN") ||
//         roles.includes("ROLE_EMP") ||
//         roles.includes("ROLE_HR") ||
//         roles.includes("ROLE_IT_MANAGER") ||
//         roles.includes("ROLE_FINANCE") ||
//         roles.includes("ROLE_SYSTEM_ADMIN"),
//     },
//     {
//       label: "Mail Generate",
//       icon: "material-symbols:event-outline-rounded",
//       activeIcon: "material-symbols:event",
//       link: "/mail-generate",
//       visible: roles.includes("ROLE_IT_MANAGER"),
//     },
//     // ...(roles.includes("ROLE_ADMIN")
//     //   ? [
//     //       {
//     //         label: "Employee Manager",
//     //         icon: "material-symbols:group-outline",
//     //         activeIcon: "material-symbols:group",
//     //         link: "/emp-management",
//     //         visible:
//     //           roles.includes("ROLE_ADMIN") ||
//     //           roles.includes("ROLE_MANAGER") ||
//     //           roles.includes("ROLE_HR") ||
//     //           roles.includes("ROLE_IT_MANAGER") ||
//     //           roles.includes("ROLE_FINANCE") ||
//     //           roles.includes("ROLE_SYSTEM_ADMIN"),
//     //       },
//     //     ]
//     //   : []),
//     // {
//     //   label: "Employee Onboarding",
//     //   icon: "material-symbols:person-add-outline",
//     //   activeIcon: "material-symbols:person-add",
//     //   link: "/emp-onbaord",
//     //   visible:
//     //     roles.includes("ROLE_ADMIN") ||
//     //     roles.includes("ROLE_MANAGER") ||
//     //     roles.includes("ROLE_HR") ||
//     //     roles.includes("ROLE_IT_MANAGER") ||
//     //     roles.includes("ROLE_FINANCE"),
//     // },

//     // {
//     //   label: "Appointment Status",
//     //   icon: "material-symbols:person-add-outline",
//     //   activeIcon: "material-symbols:person-add",
//     //   link: "/onboardAppoint-approve", // since both conditions are the same
//     //   visible:
//     //     roles.includes("ROLE_ADMIN") ||
//     //     roles.includes("ROLE_MANAGER") ||
//     //     roles.includes("ROLE_HR") ||
//     //     roles.includes("ROLE_IT_MANAGER") ||
//     //     roles.includes("ROLE_FINANCE"), // show only for admin
//     // },
//     // {
//     //   label: "Company Master",
//     //   icon: "material-symbols:person-add-outline",
//     //   activeIcon: "material-symbols:person-add",
//     //   link: "/company-maslist", // since both conditions are the same
//     //   visible: roles.includes("ROLE_ADMIN"),
//     // },
//     {
//       label: "Department & Role",
//       icon: "mingcute:department-line",
//       activeIcon: "mingcute:department-fill",
//       link: "/deptrole", // since both conditions are the same
//       visible:
//         roles.includes("ROLE_ADMIN") || roles.includes("ROLE_SYSTEM_ADMIN"), // show only for admin
//     },
//     {
//       label: "Tenant Management",
//       icon: "mingcute:department-line",
//       activeIcon: "mingcute:department-fill",
//       link: "/tenent", // since both conditions are the same
//       visible: roles.includes("ROLE_SYSTEM_ADMIN"), // show only for admin
//     },
//     // {
//     //   label: "CMS",
//     //   icon: "material-symbols-light:content-copy-rounded",
//     //   activeIcon: "mingcute:department-fill",
//     //   link: "/annexure-salary", // since both conditions are the same
//     //   visible: roles.includes("ROLE_ADMIN"), // show only for admin
//     // },
//     // {
//     //   label: "Resume Parser",
//     //   icon: "material-symbols-light:content-copy-rounded",
//     //   activeIcon: "mingcute:department-fill",
//     //   link: "/resume-parsur", // since both conditions are the same
//     //   visible: roles.includes("ROLE_ADMIN"), // show only for admin
//     // },
//     // {
//     //   label: "Invoice",
//     //   icon: "material-symbols-light:content-copy-rounded",
//     //   activeIcon: "mingcute:department-fill",
//     //   link: "/list-invoice", // since both conditions are the same
//     //   visible:
//     //     roles.includes("ROLE_ADMIN") ||
//     //     roles.includes("ROLE_IT_MANAGER") ||
//     //     roles.includes("ROLE_FINANCE"), // show only for admin
//     // },
//     // {
//     //   label: "Work Order",
//     //   icon: "material-symbols-light:content-copy-rounded",
//     //   activeIcon: "mingcute:department-fill",
//     //   link: "/work-orderlist", // since both conditions are the same
//     //   visible:
//     //     roles.includes("ROLE_ADMIN") ||
//     //     roles.includes("ROLE_IT_MANAGER") ||
//     //     roles.includes("ROLE_FINANCE"), // show only for admin
//     // },
//     // {
//     //   label: "Offboarding",
//     //   icon: "material-symbols:person-remove",
//     //   activeIcon: "material-symbols:person-remove",
//     //   link: "/off-boarding", // since both conditions are the same
//     //   visible:
//     //     roles.includes("ROLE_ADMIN") ||
//     //     roles.includes("ROLE_HR") ||
//     //     roles.includes("ROLE_MANAGER") ||
//     //     roles.includes("ROLE_FINANCE") ||
//     //     roles.includes("ROLE_IT_MANAGER"),
//     // },
//     {
//       label: "Employee Offboarding",
//       icon: "material-symbols:person-remove",
//       activeIcon: "material-symbols:person-remove",
//       link: "/off-boarding-employee", // since both conditions are the same
//       visible:
//         roles.includes("ROLE_ADMIN") ||
//         roles.includes("ROLE_HR") ||
//         roles.includes("ROLE_MANAGER") ||
//         roles.includes("ROLE_FINANCE") ||
//         roles.includes("ROLE_IT_MANAGER") ||
//         roles.includes("ROLE_EMP"),
//     },
//     //     {
//     //   label: getOffboardingLabel(roles),
//     //   icon: "material-symbols:person-remove",
//     //   activeIcon: "material-symbols:person-remove",
//     //   link: "/off-boarding",
//     //   visible:
//     // roles.includes("ROLE_ADMIN") ||
//     // roles.includes("ROLE_HR") ||
//     // roles.includes("ROLE_MANAGER") ||
//     // roles.includes("ROLE_EMP") ||
//     // roles.includes("ROLE_FINANCE") ||
//     // roles.includes("ROLE_IT_MANAGER") ,

//     // },
//     {
//       label: "Accounts",
//       icon: "material-symbols:account-balance",

//       visible:
//         roles.includes("ROLE_ADMIN") ||
//         roles.includes("ROLE_FINANCE") ||
//         roles.includes("ROLE_IT_MANAGER"),

//       children: [
//         {
//           label: "Company Master",
//           link: "/company-maslist",
//           visible: roles.includes("ROLE_ADMIN"),
//         },
//         {
//           label: "Work Order",
//           link: "/work-orderlist",
//           visible:
//             roles.includes("ROLE_ADMIN") ||
//             roles.includes("ROLE_FINANCE") ||
//             roles.includes("ROLE_IT_MANAGER"),
//         },
//         {
//           label: "Invoice",
//           link: "/list-invoice",
//           visible:
//             roles.includes("ROLE_ADMIN") ||
//             roles.includes("ROLE_FINANCE") ||
//             roles.includes("ROLE_IT_MANAGER"),
//         },
//       ],
//     },
//     // {
//     //   label: "Offboarding Configuration",
//     //   icon: "material-symbols:settings",
//     //   activeIcon: "material-symbols:settings",
//     //   link: "/off-boarding-config", // since both conditions are the same
//     //   visible: roles.includes("ROLE_ADMIN"), // show only for admin
//     // },
//     // {
//     //   label: "Project Tracking",
//     //   icon: "material-symbols:business-center",
//     //   activeIcon: "material-symbols:business-center",
//     //   link: "/projectdashboard", // since both conditions are the same
//     //   visible: roles.includes("ROLE_ADMIN"), // show only for admin
//     // },
//     {
//       label: "Project Management",
//       icon: "material-symbols:business-center",
//       activeIcon: "material-symbols:business-center",
//       visible:
//         roles.includes("ROLE_ADMIN") ||
//         roles.includes("ROLE_HR") ||
//         roles.includes("ROLE_MANAGER") ||
//         roles.includes("ROLE_EMP") ||
//         roles.includes("ROLE_SYSTEM_ADMIN"),
//       children: [
//         {
//           label: "Task Tracking",
//           link: "/mytask",
//           visible:
//             roles.includes("ROLE_EMP") ||
//             roles.includes("ROLE_MANAGER") ||
//             roles.includes("ROLE_ADMIN") ||
//             roles.includes("ROLE_SYSTEM_ADMIN"),
//         },
//         {
//           label: "Project Tracking",
//           link: "/projectdashboard",
//           visible:
//             roles.includes("ROLE_MANAGER") ||
//             roles.includes("ROLE_ADMIN") ||
//             roles.includes("ROLE_SYSTEM_ADMIN"),
//         },
//         {
//           label: "Team CMS",
//           link: "/teamList",
//           visible:
//             roles.includes("ROLE_MANAGER") ||
//             roles.includes("ROLE_ADMIN") ||
//             roles.includes("ROLE_SYSTEM_ADMIN"),
//         },
//       ],
//     },
//   ];

//   useEffect(() => {
//     if (isLoggedOut) {
//       navigate("/");
//     }
//   }, [isLoggedOut, navigate]);

//   const [openDropdown, setOpenDropdown] = useState(null);

//   const toggleDropdown = (index) => {
//     setOpenDropdown(openDropdown === index ? null : index);
//   };
//   useEffect(() => {
//     menus.forEach((menu, index) => {
//       if (menu.children) {
//         const isChildActive = menu.children.some((child) =>
//           location.pathname.startsWith(child.link),
//         );

//         if (isChildActive) {
//           setOpenDropdown(index);
//         }
//       }
//     });
//   }, [location.pathname]);
//   // useEffect(() => {
//   //   menus.forEach((menu, index) => {
//   //     if (menu.children) {
//   //       const isChildActive = menu.children.some((child) =>
//   //         location.pathname.startsWith(child.link),
//   //       );
//   //       if (isChildActive) {
//   //         setOpenDropdown(index);
//   //       }
//   //     }
//   //   });
//   // }, [location.pathname]);
//   useEffect(() => {
//     const savedScroll = sessionStorage.getItem("sidebarScroll");

//     if (sidebarRef.current && savedScroll) {
//       requestAnimationFrame(() => {
//         sidebarRef.current.scrollTop = Number(savedScroll);
//       });
//     }
//   }, []);
//   const handleSidebarScroll = () => {
//     if (sidebarRef.current) {
//       sessionStorage.setItem("sidebarScroll", sidebarRef.current.scrollTop);
//     }
//   };
//   const isParentActive = (menu) => {
//     if (!menu.children) return false;
//     return menu.children.some((child) =>
//       location.pathname.startsWith(child.link),
//     );
//   };
//   const handleMenuClick = () => {
//     if (sidebarRef.current) {
//       sessionStorage.setItem("sidebarScroll", sidebarRef.current.scrollTop);
//     }
//   };
//   return (
//     <div className="layout-wrapper">
//       {/* Sidebar */}
//       <aside
//         ref={sidebarRef}
//         onScroll={handleSidebarScroll}
//         className={`sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}
//         style={{
//           height: "100vh",
//           overflowY: "auto",
//           overflowX: "hidden",

//           top: 0,
//         }}
//       >
//         {/* <ul className="menu-list ">
//           {menus.map(
//             (menu, index) =>
//               menu.visible !== false && (
//                 <li key={index} className="my-2">
//                   <Link
//                     to={menu.link}
//                     className={`menu-item menus-btn  ${
//                       location.pathname === menu.link ? "active" : ""
//                     }`}
//                   >
//                     <Icon
//                       icon={
//                         location.pathname === menu.link && menu.activeIcon
//                           ? menu.activeIcon
//                           : menu.icon
//                       }
//                       className="me-2 fs-5"
//                     />
//                     {!isSidebarCollapsed && (
//                       <span className="menu-label ">{menu.label}</span>
//                     )}
//                   </Link>
//                 </li>
//               )
//           )}
//         </ul> */}

//         <ul className="menu-list">
//           {menus.map(
//             (menu, index) =>
//               menu.visible !== false && (
//                 <li key={index} className="my-2">
//                   {/* Parent Menu */}
//                   {menu.children ? (
//                     <>
//                       <div
//                         className={`menu-item menus-btn d-flex align-items-center justify-content-between ${
//                           isParentActive(menu) ? "active" : ""
//                         }`}
//                         onClick={() => toggleDropdown(index)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <div className="d-flex align-items-center">
//                           <Icon icon={menu.icon} className="me-2 fs-5" />
//                           {!isSidebarCollapsed && (
//                             <span className="menu-label">{menu.label}</span>
//                           )}
//                         </div>

//                         {!isSidebarCollapsed && (
//                           <Icon
//                             icon={
//                               openDropdown === index
//                                 ? "mdi:chevron-up"
//                                 : "mdi:chevron-down"
//                             }
//                           />
//                         )}
//                       </div>

//                       {/* Dropdown */}
//                       {openDropdown === index && !isSidebarCollapsed && (
//                         <div
//                           className="submenu-wrapper "
//                           style={{
//                             backgroundColor: "#AFEAFF",
//                             borderRadius: "18px",
//                             padding: "8px 12px",
//                             boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", // Soft shadow for depth
//                             transition: "all 0.3s ease",
//                           }}
//                         >
//                           <ul className="submenu">
//                             {/*
//                             {menu.children.map((child, i) => (
//                               <li key={i}>
//                                 <Link
//                                   to={child.link}
//                                   className={`submenu-item ${location.pathname.startsWith(child.link)
//                                     ? "active"
//                                     : ""
//                                     }`}
//                                 >
//                                   {child.label}
//                                 </Link>
//                               </li>
//                             ))}
//                             */}
//                             {menu.children.map((child, i) =>
//                               child.visible ? (
//                                 <li key={i}>
//                                   <Link
//                                     to={child.link}
//                                     onClick={handleMenuClick}
//                                     className={`submenu-item ${
//                                       location.pathname.startsWith(child.link)
//                                         ? "active"
//                                         : ""
//                                     }`}
//                                   >
//                                     {child.label}
//                                   </Link>
//                                 </li>
//                               ) : null,
//                             )}
//                           </ul>
//                         </div>
//                       )}
//                     </>
//                   ) : (
//                     /* Normal Menu */
//                     <Link
//                       to={menu.link}
//                         onClick={handleMenuClick}
//                       className={`menu-item menus-btn ${
//                         location.pathname === menu.link ? "active" : ""
//                       }`}
//                     >
//                       <Icon
//                         icon={
//                           location.pathname === menu.link && menu.activeIcon
//                             ? menu.activeIcon
//                             : menu.icon
//                         }
//                         className="me-2 fs-5"
//                       />
//                       {!isSidebarCollapsed && (
//                         <span className="menu-label">{menu.label}</span>
//                       )}
//                     </Link>
//                   )}
//                 </li>
//               ),
//           )}
//         </ul>
//       </aside>

//       {/* Main Content */}
//       <main className={`main-content ${isSidebarCollapsed ? "collapsed" : ""}`}>
//         <Navbar />
//         <div className="page-content">
//           <Routes>
//             <Route path="/time-sheet" element={<AttendancePage />} />
//             <Route path="*" element={children} />
//           </Routes>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default Layout;
// ============================new trying
import React, { useEffect, useState, useRef } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  Routes,
  Route,
} from "react-router-dom";
import AttendancePage from "../pages/AttendancePage";
import Navbar from "./common/Navbar";
import "../Assets/CSS/Layouts.css"; // Import custom CSS
// import { Icon } from "@iconify/react/dist/iconify.js";
import { Icon } from "@iconify/react";
import { jwtDecode } from "jwt-decode";

export const getUserRole = (token) => {
  try {
    const decoded = jwtDecode(token);
    console.log("Decoded JWT:", decoded);

    const roles = decoded.roles || []; // roles array from token
    const userName = decoded.userName || decoded.sub || null; // subject claim

    // Expiration (exp is in seconds, convert to ms)
    const expiryTime = decoded.exp ? decoded.exp * 1000 : null;

    return { roles, userName, expiryTime };
  } catch (error) {
    console.error("Invalid token", error);
    return { roles: [], userName: null, expiryTime: null };
  }
};
const ROLE = {
  ADMIN: "ROLE_ADMIN",
  HR: "ROLE_HR",
  EMP: "ROLE_EMP",
  MANAGER: "ROLE_MANAGER",
  FINANCE: "ROLE_FINANCE",
  IT: "ROLE_IT_MANAGER",
  SYS_ADMIN: "ROLE_SYSTEM_ADMIN",
};

const hasRole = (userRoles, allowedRoles = []) =>
  allowedRoles.some((role) => userRoles.includes(role));

const Layout = ({ children }) => {
  const sidebarRef = useRef(null);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const { roles = [] } = getUserRole(token);

  const isAdmin = hasRole(roles, [ROLE.ADMIN]);
  const isHR = hasRole(roles, [ROLE.HR]);
  const isEmployee = hasRole(roles, [ROLE.EMP]);
  const isManager = hasRole(roles, [ROLE.MANAGER]);
  const isFinance = hasRole(roles, [ROLE.FINANCE]);
  const isIT = hasRole(roles, [ROLE.IT]);
  const isSystemAdmin = hasRole(roles, [ROLE.SYS_ADMIN]);

  const isAdminPanelUser = hasRole(roles, [
    ROLE.ADMIN,
    ROLE.HR,
    ROLE.IT,
    ROLE.FINANCE,
    ROLE.SYS_ADMIN,
  ]);
  // Check if user is on Onboarding Profile page

  const getOffboardingLabel = (roles) => {
    if (roles.includes("ROLE_ADMIN")) return "Admin Offboarding";
    if (roles.includes("ROLE_HR")) return "HR Offboarding";
    if (roles.includes("ROLE_MANAGER")) return "Manager Offboarding";
    if (roles.includes("ROLE_EMP")) return "Employee Offboarding";
    if (roles.includes("ROLE_FINANCE")) return "Offboarding";
    if (roles.includes("ROLE_IT_MANAGER")) return "Offboarding";
    return "Offboarding";
  };

  const menus = React.useMemo(
    () => [
      {
        label: "Dashboard",
        icon: "mage:dashboard",
        activeIcon: "mage:dashboard-fill",
        link: isAdminPanelUser ? "/admin-dashboard" : "/employee-dashboard",
        visible:
          isAdmin ||
          isEmployee ||
          isManager ||
          isHR ||
          isIT ||
          isFinance ||
          isSystemAdmin,
      },
      {
        label: "Salary Slip",
        icon: "mage:dashboard",
        activeIcon: "mage:dashboard-fill",
        link: "/salaryslip-table",
        visible:
          isAdmin ||
          isEmployee ||
          isManager ||
          isHR ||
          isIT ||
          isFinance ||
          isSystemAdmin,
      },

      {
        label: "My Dashboard",
        icon: "material-symbols:event-outline-rounded",
        activeIcon: "material-symbols:event",
        link: "/employee-dashboard",
        visible: isAdmin,
      },

      // ================= TEAM MANAGEMENT =================

      {
        label: "My Team",
        icon: "material-symbols:group-outline",
        visible: isAdmin || isManager || isHR,

        children: [
          {
            label: "Employee Manager",
            link: "/emp-management",
            visible: isAdmin || isManager || isHR,
          },
          {
            label: "Employee Timesheet",
            link: "/admin-timesheet",
            visible: isAdmin || isManager || isHR,
          },
          {
            label: "Create Team",
            link: "/teamList",
            visible: isAdmin || isManager,
          },
          {
            label: "Project Tracking",
            link: "/projectdashboard",
            visible: isAdmin || isManager,
          },
        ],
      },

      // ================= EMPLOYEE MANAGEMENT =================

      {
        label: "Employee Management",
        icon: "material-symbols:person-add-outline",
        visible: isAdmin || isManager || isHR,

        children: [
          {
            label: "Employee Onboarding",
            link: "/emp-onbaord",
            visible: isAdmin || isHR,
          },
          {
            label: "Appointment Status",
            link: "/onboardAppoint-approve",
            visible: isAdmin || isManager || isHR,
          },
          {
            label: "Offboarding",
            link: "/off-boarding",
            visible: isAdmin || isHR || isManager,
          },
          {
            label: "Offboarding Configuration",
            link: "/off-boarding-config",
            visible: isAdmin,
          },
          {
            label: "Salary Annexure",
            link: "/salary-annexure",
            visible: isAdmin,
          },
        ],
      },

      // ================= TIMESHEET =================

      {
        label: "My Timesheet",
        icon: "solar:sort-by-time-linear",
        activeIcon: "solar:sort-by-time-bold",
        link: "/timesheet",
        visible: isEmployee || isManager || isAdmin,
      },

      // ================= LEAVE =================

      {
        label: "Leave Management",
        icon: "material-symbols:event-outline-rounded",
        activeIcon: "material-symbols:event",
        link: "/leave-management",
        visible:
          isAdmin ||
          isManager ||
          isEmployee ||
          isHR ||
          isIT ||
          isFinance ||
          isSystemAdmin,
      },

      // ================= MAIL =================

      {
        label: "Mail Generate",
        icon: "material-symbols:mail-outline",
        activeIcon: "material-symbols:mail",
        link: "/mail-generate",
        visible: isIT,
      },

      // ================= MASTER =================

      {
        label: "Department & Role",
        icon: "mingcute:department-line",
        activeIcon: "mingcute:department-fill",
        link: "/deptrole",
        visible: isAdmin || isSystemAdmin,
      },

      {
        label: "Tenant Management",
        icon: "mingcute:department-line",
        activeIcon: "mingcute:department-fill",
        link: "/tenent",
        visible: isSystemAdmin,
      },

      // ================= OFFBOARDING =================

      {
        label: "Employee Offboarding",
        icon: "material-symbols:person-remove",
        activeIcon: "material-symbols:person-remove",
        link: "/off-boarding-employee",
        visible:
          isAdmin || isHR || isManager || isFinance || isIT || isEmployee,
      },

      // ================= ACCOUNTS =================

      {
        label: "Accounts",
        icon: "material-symbols:account-balance",
        visible: isAdmin || isFinance || isIT,

        children: [
          {
            label: "Company Master",
            link: "/company-maslist",
            visible: isAdmin,
          },
          {
            label: "Work Order",
            link: "/work-orderlist",
            visible: isAdmin || isFinance || isIT,
          },
          {
            label: "Work Order Status",
            link: "/work-orderStatus",
            visible: isAdmin || isFinance || isIT,
          },
          {
            label: "Invoice",
            link: "/list-invoice",
            visible: isAdmin || isFinance || isIT,
          },
        ],
      },

      // ================= PROJECT =================

      {
        label: "Project Management",
        icon: "material-symbols:business-center",
        activeIcon: "material-symbols:business-center",
        visible: isAdmin || isHR || isManager || isEmployee || isSystemAdmin,

        children: [
          {
            label: "Task Tracking",
            link: "/mytask",
            visible: isEmployee || isManager || isAdmin || isSystemAdmin,
          },
          {
            label: "Project Tracking",
            link: "/projectdashboard",
            visible: isManager || isAdmin || isSystemAdmin,
          },
          {
            label: "Team CMS",
            link: "/teamList",
            visible: isManager || isAdmin || isSystemAdmin,
          },
        ],
      },
    ],
    [
      isAdmin,
      isHR,
      isEmployee,
      isManager,
      isFinance,
      isIT,
      isSystemAdmin,
      isAdminPanelUser,
    ],
  );
  const filteredMenus = React.useMemo(
    () =>
      menus
        .filter((menu) => menu.visible)
        .map((menu) => ({
          ...menu,
          children: menu.children?.filter((child) => child.visible),
        })),
    [menus],
  );
  useEffect(() => {
    const activeIndex = filteredMenus.findIndex((menu) =>
      menu.children?.some((child) => location.pathname.startsWith(child.link)),
    );

    setOpenDropdown((prev) => (prev === activeIndex ? prev : activeIndex));
  }, [location.pathname]);

  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (index) => {
    if (sidebarRef.current) {
      sessionStorage.setItem("sidebarScroll", sidebarRef.current.scrollTop);
    }

    setOpenDropdown((prev) => (prev === index ? null : index));
  };
  useEffect(() => {
    const savedScroll = sessionStorage.getItem("sidebarScroll");

    if (sidebarRef.current && savedScroll) {
      requestAnimationFrame(() => {
        sidebarRef.current.scrollTop = Number(savedScroll);
      });
    }
  }, [location.pathname, openDropdown]);
  useEffect(() => {
    const activeIndex = filteredMenus.findIndex((menu) =>
      menu.children?.some((child) => location.pathname.startsWith(child.link)),
    );

    if (activeIndex !== -1) {
      setOpenDropdown(activeIndex);
    }
  }, [location.pathname, filteredMenus]);

  const handleSidebarScroll = () => {
    if (sidebarRef.current) {
      sessionStorage.setItem("sidebarScroll", sidebarRef.current.scrollTop);
    }
  };
  const isParentActive = React.useCallback(
    (menu) =>
      menu.children?.some((child) => location.pathname.startsWith(child.link)),
    [location.pathname],
  );
  const handleMenuClick = () => {
    if (sidebarRef.current) {
      sessionStorage.setItem("sidebarScroll", sidebarRef.current.scrollTop);
    }
  };

  return (
    <div className="layout-wrapper">
      {/* Sidebar */}
      <aside
        ref={sidebarRef}
        onScroll={handleSidebarScroll}
        className={`sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}
        style={{
          height: "100vh",
          overflowY: "auto",
          overflowX: "hidden",

          top: 0,
        }}
      >
        {/* <ul className="menu-list ">
          {menus.map(
            (menu, index) =>
              menu.visible !== false && (
                <li key={index} className="my-2">
                  <Link
                    to={menu.link}
                    className={`menu-item menus-btn  ${
                      location.pathname === menu.link ? "active" : ""
                    }`}
                  >
                    <Icon
                      icon={
                        location.pathname === menu.link && menu.activeIcon
                          ? menu.activeIcon
                          : menu.icon
                      }
                      className="me-2 fs-5"
                    />
                    {!isSidebarCollapsed && (
                      <span className="menu-label ">{menu.label}</span>
                    )}
                  </Link>
                </li>
              )
          )}
        </ul> */}

        <ul className="menu-list">
          {filteredMenus.map((menu, index) => (
            <li key={menu.label} className="my-2">
              {menu.children ? (
                <>
                  {/* Parent Menu */}
                  <div
                    className={`menu-item menus-btn d-flex align-items-center justify-content-between ${isParentActive(menu) ? "active" : ""
                      }`}
                    onClick={() => toggleDropdown(index)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center">
                      <Icon icon={menu.icon} className="me-2 fs-5" />

                      {!isSidebarCollapsed && (
                        <span className="menu-label">{menu.label}</span>
                      )}
                    </div>

                    {!isSidebarCollapsed && (
                      <Icon
                        icon={
                          openDropdown === index
                            ? "mdi:chevron-up"
                            : "mdi:chevron-down"
                        }
                      />
                    )}
                  </div>

                  {/* Dropdown */}
                  {openDropdown === index && !isSidebarCollapsed && (
                    <div
                      className="submenu-wrapper"
                      style={{
                        // backgroundColor: "#AFEAFF",
                        // borderRadius: "18px",
                        padding: "8px 12px",
                        // boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                        // transition: "all 0.3s ease",
                      }}
                    >
                      <ul className="submenu">
                        {menu.children.map((child) => (
                          <li key={child.label}>
                            <Link
                              to={child.link}
                              onClick={handleMenuClick}
                              className={`submenu-item ${location.pathname.startsWith(child.link)
                                ? "active"
                                : ""
                                }`}
                            >
                              {child.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </>
              ) : (
                <Link
                  to={menu.link}
                  onClick={handleMenuClick}
                  className={`menu-item menus-btn ${location.pathname === menu.link ? "active" : ""
                    }`}
                >
                  <Icon
                    icon={
                      location.pathname === menu.link && menu.activeIcon
                        ? menu.activeIcon
                        : menu.icon
                    }
                    className="me-2 fs-5"
                  />

                  {!isSidebarCollapsed && (
                    <span className="menu-label">{menu.label}</span>
                  )}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </aside>

      {/* Main Content */}
      <main className={`main-content ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <Navbar />
        <div className="page-content">
          <Routes>
            <Route path="/time-sheet" element={<AttendancePage />} />
            <Route path="*" element={children} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default Layout;
